/**
 * Classe de formatação do tipo Decimal Rate Km
 * @author: Adalto Junior e Christiano Milfont
 * DATE: 09/10/2014
 */


Monet.Format = Monet.Format|| {};
Monet.Format.DECIMAL_RATE_KM = (function () {

    function DECIMAL_RATE_KM(value) {

        Monet.Format.DECIMAL.apply(this, arguments);

        this.convertFromNonMetric = function() {
            this.value = this.value / 1.609344;
            return this;
        };

        this.convertToNonMetric = function() {
            this.value = this.value * 1.609344;
            return this;
        };

        this.toGrid = function () {

            if (Monet.Session.User.unitSystem === 'NON_METRIC') {

                this.convertToNonMetric();
                this.format();

            } else {

                this.format();

            }

            return this;

        };
    }

    return DECIMAL_RATE_KM;

}());